<template lang="html">
  <div class="empty-state-container d-table">
    <div class="empty-state text-center d-table-cell align-middle">
      <i class="fi flaticon-015-pincushion nav-icon mb1-4" ></i>
      <h3 class="align-middle primary">Invite only...</h3>
      <br />
      <p class="lead secondary">
        Currently only <b>Stylists</b> can curate capsules.
      </p>

      <p>
        To <b>request an invite</b>, please email: <a class="btn btn-outline-secondary get-in-touch" href="mailto:paris@unstitched.xyz">paris@unstitched.xyz</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TailorMemberEmptyStateContent'
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.empty-state-container {
  width: 100%;
  height: 100%;
  margin: 0 auto;

  .nav-icon {
    font-size: 124px;
  }
}

.empty-state {
  font-weight: 300;
  text-decoration: none;
  color: #a9a9a9;

  .primary, .secondary {
    font-weight: 300;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tailor/TailorMemberEmptyStateContent.vue